import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { isAllowed } from "../../../shared/utils/permissions";
import colores from "../../../shared/constants/styles";
import TokenService from "../../../services/token";
import rutas from "../../../routes/constants/routes";

const MenuPerfil = (props: any) => {
  const { Nombre, identificationId, numeroDoc, email } = props.usuario;
  const clienteSeleccionado = window.localStorage.getItem("selectedClient")
    ? JSON.parse(window.localStorage.getItem("selectedClient") as string)
    : null;
  const opcionesPerfil = [
    {
      titulo: "Mi perfil",
      link: `/cliente/perfil`,
      permiso: 21,
    },
    {
      titulo: "Cambiar Contraseña",
      link: `/changepassword/${numeroDoc.trim()}/${identificationId}/${email.trim()}`,
      permiso: 22,
    },
    {
      titulo: "Contacto",
      link: `/formulario_contacto`,
      permiso: 22,
    },
    {
      titulo: "Configuración de correos",
      link: `/clientes/tiposEmail`,
      permiso: 41,
    },
  ];

  const BorrarSession = () => {
    localStorage.removeItem("LocalSession");
    localStorage.removeItem("selectedClient");
    TokenService.clear();
    window.location.assign(rutas.LOGIN);
  };

  return (
    <li className="nav-item dropdown my-auto" style={{ marginRight: "0.7rem" }}>
      <a
        className="nav-link dropdown-toggle"
        style={{ textDecoration: "none", color: "white" }}
        id="navbarDropdown"
        role="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        {clienteSeleccionado
          ? `${Nombre} (${
              clienteSeleccionado[clienteSeleccionado?.length - 1]
                ?.nombreFantasia
            })`
          : Nombre}
      </a>
      <ul
        className="dropdown-menu dropdown-menu-end"
        aria-labelledby="navbarDropdown"
        style={{ backgroundColor: colores.rojo }}
      >
        {opcionesPerfil?.map(
          (o) =>
            isAllowed(o.permiso) && (
              <li>
                <Link
                  className="dropdown-item"
                  href="#"
                  to={o.link}
                  style={{ textDecoration: "none", color: "white" }}
                >
                  {o.titulo}
                </Link>
              </li>
            ),
        )}
        <li>
          <Link
            className="dropdown-item"
            to="#"
            onClick={BorrarSession}
            style={{ textDecoration: "none", color: "white" }}
          >
            Cerrar Sesión
          </Link>
        </li>
      </ul>
    </li>
  );
};

export default withRouter(connect((state) => ({}))(MenuPerfil));
